export default {
    diseaseTitle: "عنوان بیماری",
    necessaryActions: "اقدامات لازم",
    description: "توضیحات"
}